import React from "react";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";
import {
    SPACING_4,
    SPACING_16,
    SPACING_20,
    SPACING_24,
    SPACING_40,
    SPACING_60,
} from "../common/styles/spacing";
import OptifleetLogo from "../common/assets/OptifleetLogo";
import DispatchLogo from "../common/assets/DispatchLogo";
import { WHITE } from "../common/styles/colors";

import User from "../User";
import Clock from "./components/Clock";
import { RootState } from "../../store";
import { SiteDetails } from "../User/userSlice";
import { FONT_1 } from "../common/styles/fonts";

const Header = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;

    padding: ${SPACING_4} ${SPACING_20};

    height: ${SPACING_60};

    background: ${WHITE};

    #logo_optifleet,
    #logo_dispatch {
        margin: auto 0;
    }

    #logo_optifleet {
        height: ${SPACING_24};
    }

    #logo_dispatch {
        height: ${SPACING_16};
        margin-left: ${SPACING_40};
        margin-right: auto;
    }

    @media (max-width: 1069px) {
        #logo_dispatch {
            opacity: 0;
        }

        time {
            font-size: ${FONT_1};
        }
    }
`;

const StyledClock = styled(Clock)`
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);

    margin: auto;
`;

export default ({ className }: { className?: string }) => {
    const { selectedSite } = useSelector<RootState, SiteDetails>((state) => state.user.siteDetails);

    return (
        <Header className={className}>
            <OptifleetLogo />
            <DispatchLogo />
            <StyledClock timezone={selectedSite?.timezone} />
            <User />
        </Header>
    );
};
